import { inject, provideAppInitializer } from '@angular/core';
import { DEV_SETTINGS_KEY, DevSettings } from '@wz-decorators/auto-form-filler';
import { environment } from '@wz-environments';
import { CAR_QUOTATION_DETAILS_KEY, CAR_RISK_STORAGE_KEY } from '@wz-services';
import { QuotationApiModels } from 'models/api/quotation-api.models';
import { ConfigurationModels } from '../../../../models/configuration.models';
import { WzDateValidators } from '../../tunnelsante-forms/validators/date-validators';
import {
  projectAutomobileRiskResponse,
  projectQuotationDataDetailsResponse,
} from '../projectors/quotation-projector';
import { ConfigurationService } from '../services/configuration.service';
import { LoggerService } from '../services/logger/logger.service';
import { ResourcesService } from '../services/resources/resources.service';

export const wzCoreInitializerFactory = provideAppInitializer(() => {
  const configService = inject(ConfigurationService);
  const logger = inject(LoggerService);
  const resources = inject(ResourcesService);
  return initTunnelSanteApp(configService, logger, resources)();
});

export function initTunnelSanteApp(
  configService: ConfigurationService,
  loggerService: LoggerService,
  resService: ResourcesService,
) {
  return () =>
    initConfiguration(configService, loggerService).then((cfg) => {
      initStaticValidatorInjection(resService);
      ConfigurationModels.Configuration.setGlobal(cfg);
      //loadGoogleMapsScript(cfg.googleMapsApiKey, loggerService);
      initWindowsFunctions();
      hideLoader();
    });
}

export function initStaticValidatorInjection(resService: ResourcesService) {
  WzDateValidators.setResourcesService(resService);
}

export function loadGoogleMapsScript(
  googleMapApiKey: string,
  loggerService: LoggerService,
) {
  let script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapApiKey}&libraries=places`;
  document.body.appendChild(script);
  loggerService.log('GoogleMapApi initialized');
}

export function initConfiguration(
  config: ConfigurationService,
  loggerService: LoggerService,
) {
  return config.init().then((conf) => {
    loggerService.initialize(!environment.production);
    (<any>window).logger = loggerService;
    loggerService.log('Logger initialized');
    return conf;
  });
}

export function hideLoader() {
  const loaderEl = document.getElementById('loader');
  const removeLoader = () => {
    if (loaderEl) {
      loaderEl.classList.add('fadeOut');
      setTimeout(() => {
        if (loaderEl.parentNode) {
          loaderEl.parentNode.removeChild(loaderEl);
        }
      }, 200);
    }
  };

  removeLoader();
}

export function initWindowsFunctions() {
  const w = <any>window;

  w.importDevSettings = (
    email: string,
    mobile: string,
    autoFill: boolean,
    debug: boolean,
  ) => {
    const devSettings: DevSettings = {
      autoFill,
      mobile,
      email,
      debug,
    };

    localStorage.setItem(DEV_SETTINGS_KEY, JSON.stringify(devSettings));
  };

  w.importQuotationData = (json: string) => {
    try {
      const quotationData = JSON.parse(
        json,
      ) as QuotationApiModels.QuotationData;
      const risk = projectAutomobileRiskResponse(
        quotationData.quotationRequest.risk,
      );
      const quotationDetails = projectQuotationDataDetailsResponse(
        quotationData.pricingInfos,
        quotationData.quotationRequest,
      );
      sessionStorage.setItem(CAR_RISK_STORAGE_KEY, JSON.stringify(risk));
      sessionStorage.setItem(
        CAR_QUOTATION_DETAILS_KEY,
        JSON.stringify(quotationDetails),
      );
    } catch (error) {
      sessionStorage.removeItem(CAR_RISK_STORAGE_KEY);
      sessionStorage.removeItem(CAR_QUOTATION_DETAILS_KEY);
      console.error(error);
    }
  };
}
